import React from 'react';
import { useTranslation } from 'react-i18next';
import formattingUtils from '../../../Utils/formattingUtils';
import PackageStructureGroupRow from './PackageStructureGroupRowBeta';

const PackageStructureTierRow = ({ tier, isExpanded, onToggle }) => {
    const { t } = useTranslation();

    const totalPrice = tier.productGroups.reduce((sum, group) => {
        const groupTotal = group.products.reduce((groupSum, product) => groupSum + product.price, 0);
        return sum + groupTotal;
    }, 0);

    return (
        <div className="simulation-tier-row">
            <div className="simulation-tier-header" onClick={onToggle}>
                <div className="tier-header-left">
                    <span className="vismaicon vismaicon-sm vismaicon-expense-1"></span>
                    <span className="tier-name">{tier.name}</span>
                </div>
                <div className="tier-header-right">
                    <span className="price-value">{formattingUtils.currencyFormatter(totalPrice)}</span>
                    <span className={`expand-chevron ${isExpanded ? 'expanded' : ''}`}>
                        <span className="caret caret-lg"></span>
                    </span>
                </div>
            </div>
            {isExpanded && (
                <div className="simulation-tier-content">
                    {[...tier.productGroups]
                        .sort((a, b) => b.productGroupType - a.productGroupType)
                        .map((group) => (
                            <PackageStructureGroupRow key={group.id} group={group} />
                        ))}
                </div>
            )}
        </div>
    );
};

export default PackageStructureTierRow;
